export default {
      id: "i-personal-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-personal",
      toString: function () {
        return this.url;
      }
    }